<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>
<div class="products-container">
	<nz-tabs>
		<nz-tab nzTitle="Products">
			@if (!showProductForm) {
				<button (click)="toggleProductForm()" nz-button nzType="primary">Add New</button>
				<br />
				<br />
			}
			@if (showProductForm) {
				<app-product-form
					[product]="productService.selectedProduct$ | async"
					(onSubmit)="onProductSubmit($event)"
				></app-product-form>
				<nz-divider></nz-divider>
			}
			<app-products-table></app-products-table>
		</nz-tab>
	</nz-tabs>
</div>
